import React, { useContext } from "react";
import { Button, InputLabel, Typography } from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { UserContext } from "../../context/UserContext";
import pullListLabels from "../../util/PullListLabels";
import ROLES from "../../util/roles";
import { checkRole } from "../../util/FormUtils";

const Upload = ({ category, handleFileChange, form, allowedRoles, required, disabled }) => {
    const { user } = useContext(UserContext);
    const disabledCheck = checkRole(user, [ROLES.ADMIN]) ? false : disabled || !checkRole(user, allowedRoles);

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: " #f2f3f6",
                padding: "0.6em 1.2em",
                borderRadius: "8px",
            }}
        >
            <InputLabel htmlFor="data-file">
                {form.data[`${category}Version`] > 0
                    ? `${pullListLabels[category]}: EP${form.data.epId}, Series ${
                        form.data.pullListId
                    }, Version ${form.data[`${category}Version`]}`
                    : `${pullListLabels[category]}: EP${form.data.epId}, Series ${form.data.pullListId}`}{" "}
                {required && (
                    <span style={{ color: "#cc0000" }}>*</span>
                )}
            </InputLabel>
            <div style={{ display: "flex", alignItems: "center" }}>
                {form[category] && (
                    <div style={{ display: "flex", alignItems: "center", marginRight: "16px" }}>
                        <Typography style={{ color: "red", marginRight: "12px" }}>
                            {"Click "}
                            <Typography
                                display="inline"
                                style={{ fontWeight: "800", paddingLeft: "2px", paddingRight: "2px" }}
                            >
                                SAVE
                            </Typography>
                            {" to complete upload:"}
                        </Typography>
                        <CloudUploadIcon style={{ marginRight: "8px", color: "#757575" }}/>
                        <Typography style={{ maxWidth: "720px", overflowWrap: "break-word", wordWrap: "break-word" }}>
                            {form[category].name}
                        </Typography>
                    </div>
                )}
                <label
                    htmlFor={`${category}-file`}
                    className={disabledCheck ? "disabled-label" : "abled-label"}
                    style={{ display: "flex", alignItems: "center" }}
                >
                    <Button
                        variant="contained"
                        component="span"
                        color="primary"
                        startIcon={<UploadIcon/>}
                        disabled={disabledCheck}
                        className={disabledCheck ? "disabled-button" : "abled-button"}
                    >
                        UPLOAD
                    </Button>
                    <input
                        id={`${category}-file`}
                        type="file"
                        /*accept=".txt,.pdf,.xlsx,.xls,.docx,.doc"*/
                        disabled={disabledCheck}
                        style={{ display: "none" }}
                        onChange={(e) => {
                            const selectedFile = e.target.files[0];
                            handleFileChange(category, selectedFile, form);
                        }}
                        onClick={(e) => {
                            e.target.value = null;
                        }}
                    />
                </label>
            </div>
        </div>
    );
};

export default Upload;